module.exports = __webpack_public_path__ + "static/one-req-many-res-2-5764a6705641fd44f547c63691e6f901.png";